import { api } from '@/lib/api';
import { loadRazorpayScript, openRazorpayCheckout, UPI_ONLY_CONFIG } from '@/lib/razorpay';
import { toast } from 'sonner';

const verify = (paymentId, rsp) => api.post('/recharge/verify', {
    payment_id: paymentId, razorpay_order_id: rsp.razorpay_order_id,
    razorpay_payment_id: rsp.razorpay_payment_id, razorpay_signature: rsp.razorpay_signature,
});

// Starts payment for an admin-approved promotion. Calls done() when the flow ends.
export async function payPromotion(promo, gateway, user, done) {
    let data;
    try {
        ({ data } = await api.post(`/promotions/${promo.id}/pay`, { gateway }));
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not start payment'); done(); return; }
    if (data.gateway === 'pinelabs' && data.redirect_url) { window.location.assign(data.redirect_url); return; }
    const confirmed = async (rsp) => {
        try { await verify(data.payment_id, rsp); toast.success('Payment received! Your banner is in final review.'); }
        catch (e) { toast.error(e.response?.data?.detail || 'Could not confirm payment — we will re-check it automatically.'); }
        done();
    };
    if (data.razorpay?.mock) {
        await confirmed({ razorpay_order_id: data.razorpay.order_id, razorpay_payment_id: `pay_mock_${Date.now()}`, razorpay_signature: `mock_${Date.now()}` });
        return;
    }
    if (!(await loadRazorpayScript())) { toast.error('Razorpay failed to load. Check internet.'); done(); return; }
    openRazorpayCheckout({
        key: data.razorpay.key_id, amount: data.razorpay.amount, currency: data.razorpay.currency, order_id: data.razorpay.order_id,
        name: 'Eagle Eyes Services', description: `Featured banner · ${promo.days} days`,
        prefill: { email: user?.email, name: user?.name || '', contact: user?.mobile || user?.whatsapp || '' },
        config: UPI_ONLY_CONFIG, theme: { color: '#0E2A47' },
        handler: confirmed,
        modal: { ondismiss: done },
    }, (err) => toast.error(`Payment failed: ${err.description || 'declined'}`));
}
